import dayjs from 'dayjs';

export const formatDate = (date) => dayjs(date).format('YYYY-MM-DD HH:mm');

export const toDate = (date) => dayjs(date).format('YYYY-MM-DD');
